import { render } from "./componentModel.vue?vue&type=template&id=2823f2ef&scoped=true&ts=true"
import script from "./componentModel.vue?vue&type=script&lang=ts"
export * from "./componentModel.vue?vue&type=script&lang=ts"

import "./componentModel.vue?vue&type=style&index=0&id=2823f2ef&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2823f2ef"]])

export default __exports__